var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9226 0.744078L15.2559 4.07741C15.5814 4.40285 15.5814 4.93049 15.2559 5.25592L6.08926 14.4226C5.97293 14.5389 5.82476 14.6182 5.66344 14.6505L1.49677 15.4838C0.913668 15.6004 0.399568 15.0863 0.516188 14.5032L1.34952 10.3366C1.38179 10.1752 1.46108 10.0271 1.57742 9.91074L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078ZM9.24954 4.595L2.93434 10.9108L2.39563 13.6044L5.08916 13.0657L11.4045 6.75L9.24954 4.595ZM11.3333 2.51184L10.4287 3.41667L12.5829 5.57083L13.4882 4.66667L11.3333 2.51184Z",
    fill: "#767676"
  })));
};
export { SvgEditIcon as ReactComponent };
export default __webpack_public_path__ + "assets/46003cf2.svg";